<template>
  <v-toolbar
    color="#FFFFFF"
    fixed
    app
    clipped-left
    disable-resize-watcher="false"
    class="elevation-1"
  >
    <!--
      <v-toolbar-side-icon
        @click.stop="toggleDrawer"
        v-if="drawerToggleButton"
      ></v-toolbar-side-icon>
    -->
    <ToggleDrawerButton v-if="drawerToggleButtonVisibility" />
    <v-toolbar-title>
      <img
        :src="logo.small"
        @click="routerPush('/loginlp/report')"
        class="logo on-mouse-pointer"
        alt
      />
    </v-toolbar-title>
    <v-toolbar-items>
      <template v-if="isAdvSelectButtonVisible">
        <div
          @click="routerPush('/loginlp/report')"
          class="advertiser-name-wrapper on-mouse-pointer"
        >
          <span>{{ currentAdvertiserName }}</span>
        </div>
        <ChangeAdvertiserButton />
      </template>
    </v-toolbar-items>
    <v-spacer />
    <v-toolbar-items>
      <template v-if="hasHolidayInformation">
        <HolidaysInformation />
      </template>
      <template v-if="hasIncidentInformation" class="incidentInformation">
        <IncidentInformation @onClick="isOpenNotificationMenu = true" />
      </template>
    </v-toolbar-items>
    <v-spacer />
    <div v-if="isIOSelectButtonVisible" class="icon-wrapper">
      <v-btn @click="routerPush('/loginlp/operation')" icon>
        <v-icon>account_circle</v-icon>
      </v-btn>
      <span class="text-under-icon">アカウント</span>
    </div>
    <div v-if="isNotificationButtonVisible" class="icon-wrapper">
      <template>
        <v-menu
          v-model="isOpenNotificationMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          origin="top right"
          bottom
          offset-y
          class="icon-wrapper"
        >
          <v-btn slot="activator" class="button" icon>
            <v-icon medium>notifications</v-icon>
            <v-chip
              v-if="unreadNotificationsCount > 0"
              color="red"
              text-color="white"
              class="count"
            >
              {{ unreadNotificationsCount }}
            </v-chip>
          </v-btn>
          <NotificationTopPage
            v-if="isOpenNotificationMenu"
            :unreadRequestNotificationCount="unreadRequestNotificationCount"
            :unreadSystemNotificationCount="unreadSystemNotificationCount"
            :isHideRevenue="isHideRevenue"
            @fetchUnreadNotificationsCount="fetchUnreadNotificationsCount"
          />
        </v-menu>
      </template>
      <span class="text-under-icon">通知</span>
    </div>
    <div v-if="isHideRevenue === false" class="icon-wrapper">
      <template>
        <v-menu
          v-model="isOpenHelpMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          origin="top left"
          bottom
          offset-y
          class="icon-wrapper"
        >
          <v-btn slot="activator" class="button" icon>
            <v-icon medium>help</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(menu, index) in helpMenus"
              :key="index"
              @click="onClickHelpMenu(menu)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <span class="text-under-icon">ヘルプ</span>
    </div>
    <div v-if="isSettingButtonVisible" class="icon-wrapper">
      <v-btn @click="onClickSettingButton()" class="button" icon>
        <v-icon medium dark>settings</v-icon>
      </v-btn>
      <span class="text-under-icon">管理</span>
    </div>
    <div v-if="isAccountSettingButtonVisible" class="icon-wrapper">
      <template>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          origin="top right"
          bottom
          offset-y
        >
          <v-btn
            slot="activator"
            ref="displayEditOwnAccountButton"
            class="button"
            icon
          >
            <v-icon medium>account_circle</v-icon>
          </v-btn>
          <EditOwnAccount @close="displayEditOwnAccount" />
        </v-menu>
      </template>
      <span class="text-under-icon">アカウント</span>
    </div>
  </v-toolbar>
</template>

<script>
import dayjs from 'dayjs'
import pageApi from '@/api/pages'
import ToggleDrawerButton from '../Drawer/ToggleDrawerButton'
import ChangeAdvertiserButton from '@/components/Shared/ToolBar/ChangeAdvertiserButton'
import EditOwnAccount from '@//components/Shared/ToolBar/EditOwnAccount/EditOwnAccount'
import HolidaysInformation from './HolidaysInformation'
import IncidentInformation from './IncidentInformation'
import { getters as drawerGetters } from '@/vuex/modules/ui/drawer/constants'
import { getters as currentAdvertiserGetters } from '@/vuex/modules/currentAdvertiser/constants'
import { getters as colorThemeGetters } from '@/vuex/modules/ui/colorTheme/constants'
import NotificationTopPage from './Notification/NotificationTopPage'
import { NotificationRepository } from '@/models/Notification'
import { Account } from '@/models/Account'

export default {
  name: 'ToolBar',
  components: {
    ToggleDrawerButton,
    ChangeAdvertiserButton,
    EditOwnAccount,
    HolidaysInformation,
    IncidentInformation,
    NotificationTopPage,
  },
  data() {
    return {
      isOpenNotificationMenu: false,
      isOpenHelpMenu: false,
      unreadNotificationsCount: 0,
      unreadRequestNotificationCount: 0,
      unreadSystemNotificationCount: 0,
      isHideRevenue: undefined,
      helpMenus: [],
    }
  },
  computed: {
    logo() {
      const logo = this.$store.getters[colorThemeGetters.logo]
      return logo ? logo : { small: '', large: '' }
    },
    drawerToggleButtonVisibility() {
      return this.$store.getters[drawerGetters.toggleButton]
    },
    drawerToggleButton() {
      return this.$store.getters['drawerToggleButton/getState']
    },
    // toolbar出し分け
    isSettingButtonVisible() {
      return this.$store.getters['toolbar/isSettingButtonVisible']
    },
    isNotificationButtonVisible() {
      return this.$store.getters['toolbar/isNotificationButtonVisible']
    },
    isAccountSettingButtonVisible() {
      return this.$store.getters['toolbar/isAccountSettingButtonVisible']
    },
    isIOSelectButtonVisible() {
      return this.$store.getters['toolbar/isIOSelectButtonVisible']
    },
    isAdvSelectButtonVisible() {
      return this.$store.getters['toolbar/isAdvSelectButtonVisible']
    },
    currentAdvertiserName() {
      return this.$store.getters[currentAdvertiserGetters.currentAdvertiserName]
    },
    hasHolidayInformation() {
      return dayjs().isBefore('2024-05-07 00:00')
    },
    hasIncidentInformation() {
      return dayjs().isBefore('2023-10-06 00:00')
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    isOpenNotificationMenu(value) {
      if (value) {
        // GAへeventを送信
        this.$sendEventToGA('buttonClick', {
          buttonName: 'headerNotificationButton',
        })
      }
    },
    $route: {
      handler() {
        this.initializeHelpMenus()
      },
    },
    async isNotificationButtonVisible() {
      if (!this.isNotificationButtonVisible) return
      await this.fetchUnreadNotificationsCount()
    },
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  created() {
    this.initializeHelpMenus()
    this.setIsHideRevenue()
  },
  methods: {
    initializeHelpMenus() {
      const currentPageManuals = this.getCurrentPageManual()
      this.helpMenus = [
        { name: 'ヘルプセンター', url: 'https://go.geologic.co.jp/manual_top' },
        ...currentPageManuals,
        {
          name: '問い合わせフォーム',
          url: 'https://www.geologic.co.jp/inquiry/cs',
        },
      ]
    },
    onClickHelpMenu(menu) {
      window.open(menu.url, '_blank', 'noreferrer')
    },
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    getCurrentPageManual() {
      const currentPath = window.location.pathname
      const checkPath = currentPath.includes('/agencies/')
        ? window.location.pathname
            .split('?')[0]
            .split('/')
            .pop()
        : window.location.pathname
      switch (checkPath) {
        case '/loginlp/operation':
          return [
            {
              name: 'ダッシュボード ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_report_dashboard',
            },
          ]
        case '/loginlp/simulations':
          return [
            {
              name: 'シミュレーション ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_simulation',
            },
          ]
        case '/admin/advertisers':
          return [
            {
              name: '管理ページ ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin ',
            },
            {
              name: '広告主管理 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin_advertiser',
            },
          ]
        case '/admin/accounts':
          return [
            {
              name: '管理ページ ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin ',
            },
            {
              name: 'アカウント一覧 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin_users',
            },
          ]
        case '/admin/accounts/invitations':
          return [
            {
              name: '管理ページ ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin ',
            },
            {
              name: 'アカウント招待情報 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_admin_user_reinvite',
            },
          ]
        case 'standard_reports':
          return [
            {
              name: '標準レポート ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_report_standard',
            },
          ]
        case 'budget_progress_reports':
          return [
            {
              name: '予算進捗 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_report_runrate',
            },
          ]
        case 'interval_reports':
          return [
            {
              name: 'レポート出力 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_report_download',
            },
          ]
        case 'map_reports':
          return [
            {
              name: 'マップレポート ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_report_map',
            },
          ]
        case 'point_groups':
          return [
            {
              name: '地点管理 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_location',
            },
          ]
        case 'creatives':
          return [
            {
              name: 'クリエイティブ管理 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_creative',
            },
          ]
        case 'insertion_orders':
          return [
            {
              name: '案件管理 ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_insertion_order',
            },
            {
              name: 'キャンペーン ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_campaign',
            },
          ]
        case 'simulations':
          return [
            {
              name: 'シミュレーション ヘルプ',
              url: 'https://go.geologic.co.jp/adminmanual_simulation',
            },
          ]
        default:
          return []
      }
    },
    logout() {
      this.$store.dispatch('loginAuth/LOGOUT')
    },
    toggleDrawer() {
      this.$store.dispatch('drawer/TOGGLE')
    },
    routerPush(path) {
      this.$router.push({ path }).catch(() => {})
    },
    // 設定アイコンをclickしたとき
    async onClickSettingButton() {
      // 以下のURLの中から、権限があるものをしらべてroutingさせる
      const uriPaths = [
        // '/admin/system_owners', // TODO: システム設定画面ができたらコメント外す
        '/admin/agencies',
        '/admin/advertisers',
        '/admin/accounts',
      ]
      // ページ権限情報を取得
      const ret = await pageApi.getAuth(uriPaths)
      const urlArray = ret.data.item
      // アクセス権限があるはじめのURLを抽出
      const canAccessUrl = urlArray.find(url => {
        return url.access === true
      })
      if (canAccessUrl === undefined) {
        // どのURLにも権限がない場合は「権限なし」を送る
        this.$router.push('/no_permission').catch(() => {})
      } else {
        const path = canAccessUrl.uri
        this.$router.push({ path }).catch(() => {})
      }
    },
    displayEditOwnAccount() {
      this.$refs.displayEditOwnAccountButton.$el.click()
    },
    async fetchUnreadNotificationsCount() {
      const unreadNotificationsCountObject = await NotificationRepository.getUnreadNotificationCount()
      this.unreadNotificationsCount = unreadNotificationsCountObject.total
      this.unreadRequestNotificationCount =
        unreadNotificationsCountObject.request
      this.unreadSystemNotificationCount = unreadNotificationsCountObject.system
    },
  },
}
</script>

<style scoped lang="scss">
.button {
  margin: 0;
  color: rgba(#000, 0.54) !important;
}

.logo {
  width: 130px;
  height: 35px;
  display: block;
  /*transform: translateY(2px);*/
}

.on-mouse-pointer {
  cursor: pointer;
}

.advertiser-name-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #727272;
}

.invisible {
  opacity: 0;
  width: 0;
  min-width: 0 !important;
}

.count {
  position: absolute;
  right: -1px;
  top: -5px;
  font-size: 10px;
  height: 16px;

  ::v-deep .v-chip__content {
    padding: 0 4px;
    justify-content: center;
    min-width: 16px;
  }
}

.icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.text-under-icon {
  font-size: 10px;
  position: relative;
  top: -7px;
}
</style>
